import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject, _templateObject2;
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { gql } from '../../utils/gqlClient';
import { wrapQuery } from '../../utils/wrapQuery';
export { ssoSignup, ssoAuthTokens };
var ssoSignupMutation = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  mutation SsoSignup(\n    $ssoUserCredentials: SsoUserCredentials!\n    $userDetails: SsoUserDetails\n    $userProfile: UserProfile!\n    $clientId: String!\n  ) {\n    signUpSsoUser(\n      ssoUserCredentials: $ssoUserCredentials\n      userDetails: $userDetails\n      userProfile: $userProfile\n      clientId: $clientId\n    ) {\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n      encryptedEmail\n      encryptedCheggId\n    }\n  }\n"])));
var ssoAuthTokensMutation = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  mutation SsoAuthTokens($ssoUserCredentials: SsoUserCredentials!, $clientId: String!) {\n    ssoAuthTokens(ssoUserCredentials: $ssoUserCredentials, clientId: $clientId) {\n      userCreated\n      tokens {\n        idToken\n        accessToken\n        expires\n      }\n      encryptedCheggId\n      encryptedEmail\n    }\n  }\n"])));
function ssoSignup(_x, _x2, _x3, _x4) {
  return _ssoSignup.apply(this, arguments);
}
function _ssoSignup() {
  _ssoSignup = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(ssoUserCredentials, userDetails, userProfile, clientId) {
    var data;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return wrapQuery('ssoSignup', ssoSignupMutation, {
            ssoUserCredentials: ssoUserCredentials,
            userDetails: userDetails,
            userProfile: userProfile,
            clientId: clientId
          });
        case 2:
          data = _context.sent;
          return _context.abrupt("return", data.signUpSsoUser);
        case 4:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return _ssoSignup.apply(this, arguments);
}
function ssoAuthTokens(_x5, _x6) {
  return _ssoAuthTokens.apply(this, arguments);
}
function _ssoAuthTokens() {
  _ssoAuthTokens = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(ssoUserCredentials, clientId) {
    var data;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return wrapQuery('ssoAuthTokens', ssoAuthTokensMutation, {
            ssoUserCredentials: ssoUserCredentials,
            clientId: clientId
          });
        case 2:
          data = _context2.sent;
          return _context2.abrupt("return", data.ssoAuthTokens);
        case 4:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _ssoAuthTokens.apply(this, arguments);
}